var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ROUTER_BEFORE_NAVIGATE, ROUTER_ERROR_RAISE, ROUTER_ERROR_RESET, ROUTER_NAVIGATE, ROUTER_REJECTED, } from 'constants/ActionTypes';
const errorReducer = (state = {}, action) => {
    switch (action.type) {
        case ROUTER_BEFORE_NAVIGATE: {
            if (action.initial) {
                return state;
            }
            return Object.assign({}, state, { nextCode: null });
        }
        case ROUTER_NAVIGATE: {
            return Object.assign({}, state, { code: state.nextCode });
        }
        case ROUTER_ERROR_RAISE: {
            if (state.nextCode) {
                return state;
            }
            return Object.assign({}, state, { nextCode: action.errorCode });
        }
        case ROUTER_ERROR_RESET: {
            // remove nextCode from state object
            // eslint-disable-next-line
            const { nextCode } = state, newState = __rest(state, ["nextCode"]);
            return newState;
        }
        case ROUTER_REJECTED: {
            if (state.nextCode) {
                return state;
            }
            return Object.assign({}, state, { nextCode: action.payload.code || action.payload.status || 404 });
        }
        default:
            return state;
    }
};
export default errorReducer;
